import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CrisisButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-destructive px-5 py-3 text-sm font-medium text-destructive-foreground shadow-lg shadow-destructive/40 transition hover:scale-105"
      >
        <LifeBuoy className="h-4 w-4" />
        I need help now
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4" onClick={() => setOpen(false)}>
          <div onClick={(e) => e.stopPropagation()} className="glass max-w-md w-full rounded-3xl p-8 space-y-5">
            <h2 className="text-2xl text-gradient">You're not alone.</h2>
            <p className="text-sm text-muted-foreground">If you are in immediate danger or having thoughts of suicide, please reach out right now. Help is free, confidential, and available 24/7.</p>
            <div className="space-y-2">
              <a href="tel:988" className="block glass rounded-xl p-4 hover:border-primary/40 transition">
                <div className="text-xs text-muted-foreground">United States</div>
                <div className="font-medium">988 — Suicide & Crisis Lifeline</div>
              </a>
              <a href="tel:+919152987821" className="block glass rounded-xl p-4 hover:border-primary/40 transition">
                <div className="text-xs text-muted-foreground">India</div>
                <div className="font-medium">iCall — +91 9152987821</div>
              </a>
              <a href="tel:116123" className="block glass rounded-xl p-4 hover:border-primary/40 transition">
                <div className="text-xs text-muted-foreground">UK & Ireland</div>
                <div className="font-medium">Samaritans — 116 123</div>
              </a>
            </div>
            <Link to="/crisis" className="block">
              <Button variant="secondary" className="w-full">More resources & grounding exercise</Button>
            </Link>
            <Button variant="ghost" onClick={() => setOpen(false)} className="w-full">Close</Button>
          </div>
        </div>
      )}
    </>
  );
}
